module.exports = __webpack_public_path__ + "static/media/FangDiChan3.5f5a3c3e.png";